import { render, staticRenderFns } from "./water.vue?vue&type=template&id=27ad1be7&scoped=true"
import script from "./water.vue?vue&type=script&lang=js"
export * from "./water.vue?vue&type=script&lang=js"
import style0 from "./water.vue?vue&type=style&index=0&id=27ad1be7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ad1be7",
  null
  
)

export default component.exports